import '../style.scss';
import { useCustomLocationName } from 'views/mutual/location/hooks';
import { OverseasRealEstateFatcaType } from './fatcaType';
import { OverseasRealEstateFatcaBusinessContent } from './businessContent';
import { useOverseasRealEstateResponse } from './hooks';
import { Button, ButtonFill, ButtonSize, ButtonType } from 'views/mutual/button';

type OverseasRealEstateFatcaResponseProps = {
  navigate: (isError?: boolean) => void,
}

export const OverseasRealEstateFatcaResponse = ({navigate} : OverseasRealEstateFatcaResponseProps) => {
  useCustomLocationName('事業内容・米国納税義務（FATCA）に関する確認')
  const {formik, isFatcaAnswerValid, businessContentProps, selectionProps} = useOverseasRealEstateResponse(navigate);
  return (
    <form onSubmit={formik.handleSubmit}>
      <OverseasRealEstateFatcaBusinessContent {...businessContentProps} />
      <OverseasRealEstateFatcaType selectionProps={selectionProps} />
      <div className='response_button-wrapper'>
        <Button
          type={ButtonType.Submit}
          label="回答する"
          buttonFill={ButtonFill.black}
          buttonSize={ButtonSize.medium}
          disable={!isFatcaAnswerValid}
        />
      </div>
    </form>        
  );
}